import { Button } from 'antd';

/**
 * Pagination Controls Component
 * Provides navigation between pages of patient plans
 */
export const PaginationControls = ({
    paginationInfo,
    loading,
    currentPage,
    setCurrentPage,
    setSelectedPlanIndex,
}) => {
    return (
        <div className="col-12 mb-4">
            <div
                style={{
                    padding: '12px 16px',
                    background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
                    borderRadius: '8px',
                    border: '1px solid #bdbdbd',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: '12px',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        fontSize: '14px',
                        color: '#424242',
                    }}
                >
                    <span style={{ fontWeight: '600' }}>
                        📄 Page {paginationInfo.currentPage} of {paginationInfo.totalPages}
                    </span>
                    <span
                        style={{
                            padding: '4px 8px',
                            background: 'white',
                            borderRadius: '4px',
                            fontSize: '12px',
                        }}
                    >
                        Total: {paginationInfo.totalDocs} records
                    </span>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                        type="default"
                        disabled={!paginationInfo.hasPrevPage || loading}
                        onClick={() => {
                            setCurrentPage((prev) => prev - 1);
                            setSelectedPlanIndex(0); // Reset to first plan on page change
                        }}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                        }}
                    >
                        ← Previous
                    </Button>
                    <Button
                        type="default"
                        disabled={!paginationInfo.hasNextPage || loading}
                        onClick={() => {
                            setCurrentPage((prev) => prev + 1);
                            setSelectedPlanIndex(0); // Reset to first plan on page change
                        }}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                        }}
                    >
                        Next →
                    </Button>
                </div>
            </div>
        </div>
    );
};
